import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    physicalProperties: [],
  }),

  mutations: {
    setPhysicalProperties(state, physicalProperties) {
      Vue.set(state, "physicalProperties", physicalProperties);
    },
  },

  actions: {
    //TODO: load, update, create
    createPhysicalProperties: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/physical-properties/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadPhysicalProperties: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/physical-properties/entity").then((response) => {
        return response.data;
      });
    },

    loadPhysicalProperty: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/physical-properties/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadPublishedPhysicalProperties: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/physical-properties/entity/published").then((response) => {
        context.commit("setPhysicalProperties", response.data);
        return response.data;
      });
    },

    loadSelectedPhysicalPropertyHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/physical-properties/history/" + request.id).then((response) => {
        return response.data;
      });
    },

    deletePhysicalProperties: (context, physicalProperties) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/physical-properties/entity/" + physicalProperties.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          physicalProperties.intents = intents;
          physicalProperties.intentId = response.data.id;
          return physicalProperties;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftPhysicalProperties: (context, physicalProperties) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/physical-properties/draft/" + physicalProperties.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishPhysicalProperties: (context, physicalProperties) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/physical-properties/publish/" + physicalProperties.intentId)
        .then((response) => {
          if (response.data) {
            response.data.intentId = 0;
          }
          return response.data;
        })
        .catch((response) => {
          if (response.response.status === 500) return response.response;
        });
    },
    rejectPhysicalProperties: (context, physicalProperties) => {
      return axios.get(context.getters.getMcServiceUrl + "/physical-properties/reject/" + physicalProperties.intentId).then((response) => {
        helper.recallOrRejectEntity(physicalProperties, "physical_property");
        return response.data;
      });
    },
    sendToApprovalPhysicalProperties: (context, physicalProperties) => {
      return axios.get(context.getters.getMcServiceUrl + "/physical-properties/sendToApproval/" + physicalProperties.intentId).then((response) => {
        if (physicalProperties.intents[0].type === "CREATE_PHYSICAL_PROPERTY") {
          //console.log("create");
          physicalProperties.intents[0].status = "WAITING_APPROVAL";
        } else if (physicalProperties.intents[0].type === "UPDATE_PHYSICAL_PROPERTY") {
          //console.log("update");
          physicalProperties.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallPhysicalProperties: (context, physicalProperties) => {
      return axios.get(context.getters.getMcServiceUrl + "/physical-properties/recall/" + physicalProperties.intentId).then((response) => {
        helper.recallOrRejectEntity(physicalProperties, "physical_property");
        return response.data;
      });
    },

    cancelPhysicalProperties: (context, physicalProperties) => {
      return axios.get(context.getters.getMcServiceUrl + "/physical-properties/cancel/" + physicalProperties.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getPhysicalProperties: (state) => {
      return state.physicalProperties;
    },
    getPublishedPhysicalProperties: (state) => {
      return state.physicalProperties.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
